import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minHeight: "80vh",
    maxHeight: "80vh",
    "& fieldset": {
      padding: `${theme.shape.padding}px 0 0 0 !important`,
    },
  },
  innerDialogPaper: {
    width: 450,
  },
  tabs: {
    marginTop: -theme.shape.padding,
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& span": {
      textTransform: "none",
    },
  },
  tabPanel: {
    display: "flex",
    flexDirection: "column",
    padding: `${theme.shape.padding}px 0 ${
      theme.shape.padding * 4
    }px 0 !important`,
  },
  alert: {
    marginTop: theme.shape.padding,
  },
  textField: {
    marginTop: theme.shape.padding * 2,
  },
  formControl: {
    marginTop: theme.shape.padding * 2,
  },
  formLabel: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    marginBottom: theme.shape.padding * 2,
  },
  formControlLabel: {
    marginTop: -theme.shape.padding,
  },
  subHeaderText: {
    fontSize: 15,
    fontWeight: "bold",
  },
  dialogActions: {
    padding: theme.shape.padding,
    borderTop: `1px solid ${theme.palette.divider}`,
    justifyContent: "unset",
  },
  dialogActionsColumn: {
    flex: "1.4",
    display: "flex",
    justifyContent: "center",
    marginLeft: "0 !important",
  },
  progressDotsCol: {
    flex: "0.5",
  },
  dialogActionsLeftColumnWrapper: {
    display: "block",
    marginRight: "auto",
  },
  confirmText: {
    margin: 0,
    fontSize: 10,
  },
  dialogActionsCenterColumnWrapper: {
    display: "block",
  },
  dialogActionsRightColumnWrapper: {
    display: "block",
    marginLeft: "auto",
  },
  tableContainer: {
    marginTop: theme.shape.padding,
  },
  multipleCSV: {
    paddingTop: 25,
  },
  csvTemplate: {
    marginTop: "50px",
    textAlign: "center",

    "& a": {
      color: theme.palette.primary.main,
    },
  },
  rotateIcon: {
    animation: "$spin 2s linear infinite",
  },
  "@keyframes spin": {
    "0%": {
      transform: "rotate(360deg)",
    },
    "100%": {
      transform: "rotate(0deg)",
    },
  },
  dataRetentionWarningText: {
    fontSize: "0.75rem", // to match helper text on MUI inputs
    "& a": {
      color: theme.palette.primary.main,
    },
  },
}));
